export default {
  ADD_OCORRENCIAS(state, ocorrencias) {
    state.ocorrencias = [...state.ocorrencias, ...ocorrencias]
  },
  SET_OCORRENCIAS(state, ocorrencias) {
    state.ocorrencias = ocorrencias
  },
  ADD_EVENTOS(state, eventos) {
    state.eventos = [...state.eventos, ...eventos]
  },
  SET_EVENTOS(state, eventos) {
    state.eventos = eventos
  },
}
